import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const userPlanPageSlice = createSlice({
    name: "userPlanPageSlice",
    initialState,
    reducers: {
        setUserPlanPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setUserPlanCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setUserPlanTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setUserPlanTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetUserPlanPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setUserPlanPageLimit,
    setUserPlanCurrentPage,
    setUserPlanTotalCount,
    setUserPlanTotalPages,
    resetUserPlanPagination,
} = userPlanPageSlice.actions;

export default userPlanPageSlice.reducer;
